import { Shield, Lock } from 'lucide-react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

export const Footer = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-gradient-to-b from-black to-purple-900/10 border-t border-white/5">
      {/* Background grid with enhanced opacity */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:14px_24px] opacity-10" />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col items-start"
          >
            <h4 className="text-white font-semibold mb-4 text-xl bg-clip-text text-transparent bg-gradient-to-r from-white to-white/80">
              ACOS
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              AI-powered sales automation platform that helps you find, connect, and close more deals with unprecedented efficiency.
            </p>
            <motion.button
              onClick={scrollToForm}
              className="mt-8 px-6 py-2.5 rounded-lg bg-gradient-to-r from-purple-600 to-fuchsia-600 text-white text-sm font-medium 
                hover:from-purple-500 hover:to-fuchsia-500 transition-all duration-300 hover:scale-105 
                shadow-[0_0_20px_rgba(168,85,247,0.15)] hover:shadow-[0_0_25px_rgba(168,85,247,0.25)]"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Get Started Free
            </motion.button>
          </motion.div>

          {/* Trust */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col items-start md:items-end"
          >
            <h4 className="text-white font-semibold mb-4 text-xl bg-clip-text text-transparent bg-gradient-to-r from-white to-white/80">
              Trust & Security
            </h4>
            <div className="flex flex-col gap-4 w-full md:w-auto">
              <motion.div 
                className="flex items-center gap-4 text-gray-400 bg-white/5 p-4 rounded-xl backdrop-blur-sm
                  border border-white/5 hover:border-purple-500/20 transition-colors duration-300
                  shadow-[0_0_15px_rgba(168,85,247,0.05)] hover:shadow-[0_0_20px_rgba(168,85,247,0.15)]"
                whileHover={{ scale: 1.02, y: -2 }}
              >
                <Shield className="w-6 h-6 text-purple-400" />
                <span className="text-sm font-medium">SOC 2 Type II Certified</span>
              </motion.div>
              <motion.div 
                className="flex items-center gap-4 text-gray-400 bg-white/5 p-4 rounded-xl backdrop-blur-sm
                  border border-white/5 hover:border-purple-500/20 transition-colors duration-300
                  shadow-[0_0_15px_rgba(168,85,247,0.05)] hover:shadow-[0_0_20px_rgba(168,85,247,0.15)]"
                whileHover={{ scale: 1.02, y: -2 }}
              >
                <Lock className="w-6 h-6 text-purple-400" />
                <span className="text-sm font-medium">GDPR Compliant</span>
              </motion.div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div 
          className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/5"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <div className="text-gray-500 text-sm mb-6 md:mb-0 hover:text-gray-400 transition-colors">
            © 2025 ACOS. All rights reserved.
          </div>
        </motion.div>
      </div>
    </footer>
  )
} 